<template>
  <path
    d="M16 0C9.37333 0 4 5.37333 4 12H0L5.33333 17.3333L10.6667 12H6.66667C6.66667 6.84 10.84 2.66667 16 2.66667C21.16 2.66667 25.3333 6.84 25.3333 12C25.3333 17.16 21.16 21.3333 16 21.3333C13.9867 21.3333 12.12 20.68 10.5867 19.6L8.69333 21.52C10.72 23.0667 13.2533 24 16 24C22.6267 24 28 18.6267 28 12C28 5.37333 22.6267 0 16 0Z"
  />
</template>
